import axios from '../request/http';

const activity = {
  //根据类型获取活动配置信息
    getActiveConfig(params) {
        // type=invite
        return axios.get("/hemei-admin/springActive/getActiveConfig", { params });
    },
    //开启/关闭活动
    changeFrozenStatus(params) {
        //activeType=open_door_red&status=0
        //status=0的时候表示开启这个活动
        //status=1的时候 表示 关闭这个活动
        return axios.get("/hemei-admin/springActive/changeFrozenStatus", { params });
    },
    //保存活动配置
    saveActiveConfig(data) {
        return axios.post("/hemei-admin/springActive/saveActiveConfig", data);
    },
    //获取26个活动的概览信息
    getTwentySixActivityOverviewInfo() {
        return axios.get("/hemei-admin/springActive/getTwentySixActivityOverviewInfo");
    },

    //邀请人管理列表
    getInviterInfoList(params) {
        return axios.get("/hemei-admin/springActive/getInviterInfoList", { params });
    },
    //获取被邀请人详细列表
    getInvitedInfoList(params) {
        return axios.get("/hemei-admin/springActive/getInvitedInfoList", { params });
    },
    //更新冻结状态
    updateFrozenInfo(params) {
        return axios.post("/hemei-admin/springActive/updateFrozenInfo", { ...params });
    },
    //获取活动用户信息列表
    getActivityUserInfoList(params) {
        return axios.get("/hemei-admin/springActive/getActivityUserInfoList", { params });
    },
    //奖励发放记录
    selectActivityRewardDetailList(params) {
        return axios.get("/hemei-admin/springActive/selectActivityRewardDetailList", { params });
    },
    //福语管理列表
    getActiveCommentList(params) {
        return axios.get("/hemei-admin/springActive/getActiveCommentList", { params });
    },
    //新增福语
    addActiveComment(data) {
        return axios.post("/hemei-admin/springActive/addActiveComment", data);
    },
    //删除福语
    delActiveComment(params) {
        return axios.get("/hemei-admin/springActive/delActiveComment", { params });
    },
    //更新福语
    updateActiveComment(data) {
        return axios.post("/hemei-admin/springActive/updateActiveComment", data);
    },
    //获取活动村列表
    getActivityVillageList(params) {
        return axios.get("/hemei-admin/springActive/getActivityVillageList", { params });
    },
    //新增活动村
    insertActivityVillage(data) {
        return axios.post("/hemei-admin/springActive/insertActivityVillage", data);
    },
    //删除活动村
    deleteActivityVillage(params) {
        return axios.get("/hemei-admin/springActive/deleteActivityVillage", { params });
    },
    //获取活动乡村列表（仅乡村id）
    getActivityVillageNoCountList(params) {
        return axios.get("/hemei-admin/springActive/getActivityVillageNoCountList", { params });
    },
    //搜索乡村信息
    searchVillageInfo(params) {
        return axios.get("/hemei-admin/springActive/searchVillageInfo", { params });
    },
    //添加发货单号
    addExpressNumber(params) {
        // rewardDetailId, expressNum, expressName
        return axios.get("/hemei-admin/springActive/addExpressNumber", { params });
    },
    //查询快递详情
    searchCourierInfo(params) {
        // expressId, expressNum
        return axios.get("/hemei-order/tool/courier/search", { params });
    }
}

export default activity;


// WEBPACK FOOTER //
// ./src/api/activity.js